import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=314c50b4&scoped=true&"
var script = {}
import style0 from "./Delivery.vue?vue&type=style&index=0&id=314c50b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c50b4",
  null
  
)

export default component.exports